import React, { useContext } from "react";
import { ReactComponent as CloudSync } from "../svgs/cloud_sync.svg";
import { TakebackQueueContext } from "../../../../takeback-queue/TakebackQueueProvider";

export const TakebackQueueIcon = () => {
  const { queueCount } = useContext(TakebackQueueContext);

  // Only show the icon if there are items in the queue
  if (!queueCount) {
    return null;
  }

  return (
    <span className="relative mr-3 order-1 ml-6">
      <CloudSync
        style={{ width: "2rem", height: "2rem" }}
        className="fill-[#A1A7C2]"
      />
      <sup className="absolute top-0 left-[-0.5rem] rounded-full w-5 h-5 bg-red text-white text-sm text-center">
        {queueCount}
      </sup>
    </span>
  );
};
